module.exports = __webpack_public_path__ + "images/emoji/bath.10a53b089e356155101b.png";